import React from 'react';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';
import PercentageFigure from '../../PercentageFigure/index.jsx';

import Column from './base.jsx';


var columnOptions = {
  id: 'd',
  title: 'Price Change Percent (24h)'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return '24h';
  }

  get overlayText() {
    return 'Price Change % in last 24 hours';
  }

  get rightAlign() {
    return true;
  }
}


class DetailColumn extends React.Component {
  render() {
    return (
      <td className="text-right">
        <PercentageFigure amount={this.props.row.priceChange24h} />
      </td>
    );
  }
}


class PriceChange24h extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    if (a.priceChange24h < b.priceChange24h) {
      return -1;
    }
    if (a.priceChange24h > b.priceChange24h) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.priceChange24h < b.priceChange24h) {
      return 1;
    }
    if (a.priceChange24h > b.priceChange24h) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default PriceChange24h;

